module.exports = __webpack_public_path__ + "img/GI.bc7533ff.png";